import React from 'react';
import PropTypes from 'prop-types';

import ButtonSet from '@ux/button-set';

/**
 * Render a banner with standard title & notice and
 * configurable choices buttons
 *
 * @param    {string}    notice            Notice the banner is displaying to customers
 * @param    {Function}  renderChoices     Render prop for choices to display
 * @param    {Function}  [renderLearnMore] Render prop for content after the title & notice
 * @param    {string}    title             Notice title for the banner
 * @param    {boolean}   visible           If false, no component returned
 * @returns  {Component} React component for the Banner to display
 */
export default function Banner({ notice, renderChoices, renderLearnMore, title, visible }) {
  if (!visible) return null;

  return (
    <div id='privacy_widget'>
      <div className='alert alert-dismissable' role='alert' aria-label='privacyAlert'>
        <div className='row'>
          <div className='col-md-7'>
            <p id='pw_banner' className='p-sm mb-0'>
              <span className='font-primary-bold'>{ title }</span>
              <br/>
              { notice }
              { renderLearnMore && renderLearnMore() }
            </p>
          </div>
          <div className='col-md-5'>
            <br/>
            <ButtonSet split className='text-center'>
              { renderChoices() }
            </ButtonSet>
          </div>
        </div>
      </div>
    </div>
  );
}

Banner.propTypes = {
  notice: PropTypes.string.isRequired,
  renderChoices: PropTypes.func.isRequired,
  renderLearnMore: PropTypes.func,
  title: PropTypes.string.isRequired,
  visible: PropTypes.bool.isRequired
};
